import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import PageTitle from '~/components/PageTitle';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';

const RenderTableTitle = () => (
  <TableHead>
    <TableRow style={{ height: 48 }}>
      <T_TitleCell style={{ width: 63 }} />
      <T_TitleCell colSpan={2} style={{ fontSize: 20 }} color='#247691' text='行政程序項目' />
      <T_TitleCell style={{ fontSize: 20 }} color='#247691' text='預計完成時間' />
      <T_TitleCell style={{ fontSize: 20 }} color='#247691' text='實際完成時間' />
      <T_TitleCell style={{ fontSize: 20 }} color='#247691' text='進度說明' justifyContent='start' />
      <T_TitleCell style={{ width: 50 }} />
    </TableRow>
  </TableHead>
);

const FirstSecondRow = ({ textAry = [] }) => {
  const cellStyle = { fontSize: 14 };
  return (
    <T_TableRow>
      <TableCell />
      <TableCell align='right' style={{ ...cellStyle, fontWeight: 700 }}>{textAry[0]}</TableCell>
      <TableCell align='left' style={{ ...cellStyle, fontWeight: 700 }}>{textAry[1]}</TableCell>
      <TableCell align='center' style={cellStyle}>{textAry[2]}</TableCell>
      <TableCell align='center' style={cellStyle}>{textAry[3]}</TableCell>
      <TableCell align='left' style={{ ...cellStyle, color: '#2057E4' }}>{textAry[4]}</TableCell>
      <TableCell />
    </T_TableRow>
  );
};

const ThirdRowTitle = ({ text = '' }) => {
  const cellStyle = { fontSize: 14 };
  return (
    <T_TableRow>
      <TableCell style={{ borderWidth: 0 }} />
      <TableCell style={{ borderWidth: 0 }} />
      <TableCell align='left' colSpan={5} style={{ ...cellStyle, fontWeight: 700, borderWidth: 0 }}>{text}</TableCell>
    </T_TableRow>
  );
};

const ThirdRowData = ({ data = {} }) => {
  const cellStyle = { fontSize: 14 };
  return (
    <T_TableRow>
      <TableCell style={{ borderWidth: 0 }} colSpan={2} />
      <TableCell align='left' style={{ ...cellStyle, color: '#247691' }}>{data.project}</TableCell>
      <TableCell align='center' style={{ ...cellStyle, color: '#247691' }}>{data.expected_date}</TableCell>
      <TableCell align='center' style={{ ...cellStyle, color: '#247691' }}>{data.actual_date}</TableCell>
      <TableCell align='left' style={{ ...cellStyle, color: '#2057E4' }}>{data.illustrate}</TableCell>
      <TableCell style={{ borderWidth: 0 }} />
    </T_TableRow>
  );
};

const ThirdRow = () => {
  const GisWindViewData = useSelector(state => state.data.GisWindViewData || {});
  const { construction_stage = [] } = GisWindViewData;
  const cellStyle = { fontSize: 14 };
  return ([
    <T_TableRow key={1}>
      <TableCell style={{ borderWidth: 0 }} />
      <TableCell align='right' style={{ ...cellStyle, fontWeight: 700, borderWidth: 0 }}>三、</TableCell>
      <TableCell align='left' colSpan={5} style={{ ...cellStyle, fontWeight: 700, borderWidth: 0 }}>施工階段</TableCell>
    </T_TableRow>,
    <ThirdRowTitle key={2} text='製造進度' />,
    (construction_stage[0] || []).map((o, i) => <ThirdRowData key={`1_${i}`} data={o} />),
    <ThirdRowTitle key={3} text='運輸進度' />,
    (construction_stage[1] || []).map((o, i) => <ThirdRowData key={`2_${i}`} data={o} />),
    <ThirdRowTitle key={4} text='安裝進度' />,
    (construction_stage[2] || []).map((o, i) => <ThirdRowData key={`3_${i}`} data={o} />),
  ]);
};

const RenderTableBody = () => {
  const GisWindViewData = useSelector(state => state.data.GisWindViewData || {});
  const cellStyle = { fontSize: 14 };

  return (
    <TableBody>
      <FirstSecondRow textAry={['一、', '籌設許可', GisWindViewData.setup_reserve_get_date || '-', GisWindViewData.setup_actual_get_date || '-', GisWindViewData.setup_status || '-']} />
      <FirstSecondRow textAry={['二、', '施工許可', GisWindViewData.confirm_reserve_get_date || '-', GisWindViewData.confirm_actual_get_date || '-', GisWindViewData.confirm_status || '-']} />
      <ThirdRow />
    </TableBody>
  );
};

const RenderTable = () => {
  const GisWindViewData = useSelector(state => state.data.GisWindViewData || {});
  const haveData = Object.keys(GisWindViewData).length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody />}
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const {} = props;
  const [data, setData] = useState({ windId: '' });
  const { windId } = data;
  const dispatch = useDispatch();
  const SwitchProjectList = useSelector(state => state.data.SwitchProjectList || []);
  const GisWindViewData = useSelector(state => state.data.GisWindViewData || {});
  const { construction_stage = [] } = GisWindViewData;
  const haveData = Object.keys(GisWindViewData).length > 0;

  const onClickSearch = () => { Actions_Wind.Gis.getGisWindViewData(dispatch, { id: windId }); };

  const onExport = () => {
    if (!haveData) {
      alert('無匯出資料');
    } else {
      let name = '';
      SwitchProjectList.forEach(o => {
        if (o.value === windId)name = o.name;
      });
      const excelAry = [
        ['', '行政程序項目', '預計完成時間', '實際完成時間', '進度說明'],
        ['一、', '籌設許可', GisWindViewData.setup_reserve_get_date || '-', GisWindViewData.setup_actual_get_date || '-', GisWindViewData.setup_status || '-'],
        ['二、', '施工許可', GisWindViewData.confirm_reserve_get_date || '-', GisWindViewData.confirm_actual_get_date || '-', GisWindViewData.confirm_status || '-'],
        ['三、', '施工階段'],
        ['', '製造進度'],
        ...(construction_stage[0] || []).map(o => ['', o.project || '', o.expected_date || '', o.actual_date || '', (o.illustrate || []).join('\n')]),
        ['', '運輸進度'],
        ...(construction_stage[1] || []).map(o => ['', o.project || '', o.expected_date || '', o.actual_date || '', (o.illustrate || []).join('\n')]),
        ['', '安裝進度'],
        ...(construction_stage[2] || []).map(o => ['', o.project || '', o.expected_date || '', o.actual_date || '', (o.illustrate || []).join('\n')]),
      ];
      excel.outputAryAry({
        data: excelAry,
        fileName: `單一風場進度綜覽_${name}`,
        wrapText: true,
      });
    }
  };

  useEffect(() => () => Actions_Wind.clearKey(dispatch, { key: 'GisWindViewData' }), []);

  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='單一風場進度綜覽' />
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>
      <SearchBar style={{ marginTop: 16 }} text='風場進度綜覽' defaultOpen>
        <div style={{ display: 'flex' }}>
          <div>
            <S_Title text='風場' />
            <S_Select list={SwitchProjectList} value={windId} onChange={t => setData({ ...data, windId: t })} />
          </div>
          <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
            <S_Btn_Search onClick={onClickSearch} />
          </div>
        </div>
        <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
          <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
            <RenderTable />
            {/* {haveData && this.renderTableBar()} */}
          </div>
          {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        </div>
      </SearchBar>
    </div>
  );
};

export default App;
